<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
// App Version 1.2.0

export default {
  name: 'App',

  data: () => ({
    //
  }),
}
</script>

<style>
/* This is needed for the iframe to correctly shrink when foldable parts of display are collapsed */
.v-application__wrap {
  min-height: auto !important;
}

/* Disable scrollbar on: */

/* Chrome base browsers */
::-webkit-scrollbar {
  display: none;
}

/* Firefox */
html {
  scrollbar-width: none;
}
</style>
